module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-02.712d7ffa.png";